import Header from "../components/header/header";
import Footer from "../components/footer/footer";
import AdminDashboard from "../pages/adminDashboard/adminDashboard";
import ProtectedRoute from "../components/ProtectedRoute";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import Assessment from "../pages/assesment/assesment";
import SignUpForm from "../pages/signup/signup";
import Approval from "../components/approval/approval";
import Verification from "../components/verification/verification";
import AdminHeader from "../components/header/adminHeader";
import UserList from "../components/userList/userList";
import QuestionEditor from "../components/questionEditor/questionEditor";
import Feedback from "../components/feedback/feedback";
import Rejection from "../components/rejection/rejection";
import Payment from "../components/payment/payment";
import AdminLogin from "../pages/adminLogin/adminLogin";
import SignIn from "../pages/signIn/signIn";
import PaymentSuccess from "../components/payment/paymentSuccess";
import ForgotPassword from "../pages/forgotPassword/forgotPassword";
import ResetPassword from "../pages/resetPassword/resetPassword";
import SetPassword from "../pages/setPassword/setPassword";

function Layout() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const isPublicAuthRoute =
    location.pathname === "/sign-in" || location.pathname === "/";

  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      {!isPublicAuthRoute && (isAdminRoute ? <AdminHeader /> : <Header />)}

      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Routes>
          {/* Public Routes */}
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/" element={<SignUpForm />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/reset" element={<SetPassword />} />
          <Route path="/admin-login" element={<AdminLogin />} />

          {/* User Flow Routes */}
          <Route
            path="/verification"
            element={
              <ProtectedRoute role="member">
                <Verification />
              </ProtectedRoute>
            }
          />
          <Route
            path="/approval"
            element={
              <ProtectedRoute role="member">
                <Approval />
              </ProtectedRoute>
            }
          />
          <Route
            path="/rejection"
            element={
              <ProtectedRoute role="member">
                <Rejection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment"
            element={
              <ProtectedRoute role="member">
                <Payment />
              </ProtectedRoute>
            }
          />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route
            path="/assessment"
            element={
              <ProtectedRoute role="member">
                <Assessment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/feedback/:assessmentId"
            element={
              <ProtectedRoute role="member">
                <Feedback />
              </ProtectedRoute>
            }
          />

          {/* Admin Routes */}
          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRoute role="admin">
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-list"
            element={
              <ProtectedRoute role="admin">
                <UserList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-questions"
            element={
              <ProtectedRoute role="admin">
                <QuestionEditor />
              </ProtectedRoute>
            }
          />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>

      <Footer />
    </div>
  );
}

/**
 * ✅ Root Routing
 */
function Routing() {
  return (
    <Router>
      <Routes>
        {/* Admin dashboard full screen (no layout if needed) */}
        <Route
          path="/admin-dashboard"
          element={
            <ProtectedRoute role="admin">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        {/* All other routes */}
        <Route path="*" element={<Layout />} />
      </Routes>
    </Router>
  );
}

export default Routing;
